import Model from "../Model";

class Groupcompanydetails extends Model{

    buildUrl ({ param }) {
        return ['companyview/details', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Groupcompanydetails;